export default __webpack_public_path__ + "static/media/full5.1318adea.png";